import axios from "axios";
import { del, get, post, patch,  put } from "./study_levels_api_helper";
import * as url from "./study_levels_url_helper";





// Get features
export const getStudyLevels = () => get(url.GET_STUDY_LEVELS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewStudyLevel = (studyLevel) => post(url.ADD_NEW_STUDY_LEVEL, studyLevel, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateStudyLevel = (studyLevel) => patch(`${url.UPDATE_STUDY_LEVEL}/${studyLevel.id}`,  studyLevel);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteStudyLevel = (studyLevel) => del(`${url.DELETE_STUDY_LEVEL}/${studyLevel.id}`);







export {
  //getLoggedInUser,
  
  
};
